import React from 'react';
import { useTranslation } from 'react-i18next';
import './home.css';
import './terms.css';

import FadeInSection from '../animation/fadein_onscroll';

document.querySelectorAll('a[data-scroll]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    document.querySelector(this.getAttribute('href')).scrollIntoView({
      behavior: 'smooth'
    });
  });
});

function Terms() {
  const { t } = useTranslation();
  return (
    <div className="subpage-padding" id='start'>
      <FadeInSection>
        <h1>{t('terms.title')}</h1>
      </FadeInSection>
      <br />
      <div className="max-width">
        <FadeInSection>
            <h3>{t('terms.intro.title')}</h3>
            <h4>{t('terms.intro.1')}</h4>
            <p>{t('terms.intro.1.text')}</p>
            <h4>{t('terms.intro.2')}</h4>
            <p>{t('terms.intro.2.text')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.definitions.title')}</h3>
            <h4>{t('terms.definitions.1')}</h4>
            <p>{t('terms.definitions.1.text1')}</p>
            <p>{t('terms.definitions.1.text2')}</p>
            <p>{t('terms.definitions.1.text3')}</p>
            <p>{t('terms.definitions.1.text4')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.duration.title')}</h3>
            <p>{t('terms.duration.text')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.usage.title')}</h3>
            <h4>{t('terms.usage.access')}</h4>
            <p>{t('terms.usage.accessText')}</p>
            <h4>{t('terms.usage.tracking')}</h4>
            <p>{t('terms.usage.trackingText')}</p>
            <h4>{t('terms.usage.conduct')}</h4>
            <p>{t('terms.usage.conductText1')}</p>
            <p>{t('terms.usage.conductText2')}</p>
            <p>{t('terms.usage.conductText3')}</p>
            <p>{t('terms.usage.conductText4')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.payment.title')}</h3>
            <h4>{t('terms.payment.price')}</h4>
            <p>{t('terms.payment.priceText')}</p>
            <h4>{t('terms.payment.terms')}</h4>
            <p>{t('terms.payment.termsText')}</p>
            <h4>{t('terms.payment.other')}</h4>
            <p>{t('terms.payment.otherText')}</p>
            <h4>{t('terms.payment.cancel')}</h4>
            <p>{t('terms.payment.cancelText')}</p>
            <h4>{t('terms.payment.termination')}</h4>
            <p>{t('terms.payment.terminationText1')}</p>
            <p>{t('terms.payment.terminationText2')}</p>
            <p>{t('terms.payment.terminationText3')}</p>
            <h4>{t('terms.payment.adjustment')}</h4>
            <p>{t('terms.payment.adjustmentText1')}</p>
            <p>{t('terms.payment.adjustmentText2')}</p>
            <p>{t('terms.payment.adjustmentText3')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.dataprotection.title')}</h3>
            <h4>{t('terms.dataprotection.protection')}</h4>
            <p>{t('terms.dataprotection.protectionText')}</p>
            <h4>{t('terms.dataprotection.policy')}</h4>
            <p>{t('terms.dataprotection.policyText')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.ip.title')}</h3>
            <h4>{t('terms.ip.ownership')}</h4>
            <p>{t('terms.ip.ownershipText1')}</p>
            <h4>7.1.1</h4>
            <p>{t('terms.ip.ownershipText2')}</p>
            <p>{t('terms.ip.ownershipText3')}</p>
            <p>{t('terms.ip.ownershipText4')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.liability.title')}</h3>
            <h4>{t('terms.liability.title')}</h4>
            <p>{t('terms.liability.liabilityText1')}</p>
            <p>{t('terms.liability.liabilityText2')}</p>
            <p>{t('terms.liability.liabilityText3')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.forcemajeure.title')}</h3>
            <p>{t('terms.forcemajeure.text')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.other.title')}</h3>
            <h4>{t('terms.other.change')}</h4>
            <p>{t('terms.other.changeText')}</p>
            <h4>{t('terms.other.logo')}</h4>
            <p>{t('terms.other.logoText')}</p>
            <h4>{t('terms.other.transfer')}</h4>
            <p>{t('terms.other.transferText')}</p>
            <h4>{t('terms.other.customerTransfer')}</h4>
            <p>{t('terms.other.customerTransferText')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.confidentiality.title')}</h3>
            <h4>{t('terms.confidentiality.info')}</h4>
            <p>{t('terms.confidentiality.infoText')}</p>
            <h4>{t('terms.confidentiality.obligation')}</h4>
            <p>{t('terms.confidentiality.obligationText')}</p>
            <p>{t('terms.confidentiality.obligationText2')}</p>
            <h4>{t('terms.confidentiality.exceptions')}</h4>
            <p>{t('terms.confidentiality.exceptionsText')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.law.title')}</h3>
            <p>{t('terms.law.text')}</p>
            <h4>{t('terms.law.disputes')}</h4>
            <p>{t('terms.law.disputesText')}</p>
            <h4>{t('terms.law.contact')}</h4>
            <p>{t('terms.law.contactText')}</p>
        </FadeInSection>
        <br />
        <br />
        <FadeInSection>
            <h3>{t('terms.consent.title')}</h3>
            <p>{t('terms.consent.text')}</p>
        </FadeInSection>
        <br />
        <br />
      </div>
    </div>
  );
}

export default Terms;